import Vue from "vue"
import { beforeRouteEnter } from "@assets/js/routerPageHook.js"
import filterContainer from "@components/ui-components/filter-container/filter-container.vue"
import caseItem from "@components/ui-components/case/component.js"
import onScrollAnimate from "@assets/js/scrollAnimate.js"
import LoadMore from "@components/ui-components/load-more/load-more"
import formGreen from "@components/base/form-green.vue"
import { mapActions, mapState } from "vuex"
import { router } from "@src/routes"

export default {
  name: "index",
  data() {
    return {
      template: "<main></main>",
      casesSwiperOption: {
        spaceBetween: 32,
        parallax: true,
        speed: 700,
        loop: true,
        autoplay: {
          delay: 8000,
        },
        pagination: {
          el: ".js-cases-pag",
          clickable: true,
        },
        breakpoint: {
          920: {
            spaceBetween: 16,
          },
        },
      },
      newCases: [],
      pagination: null,
      disableLoadMore: false,
    }
  },
  computed: {
    ...mapState("mobile", ["isMobile"]),
  },
  components: {
    "filter-container-cmp": filterContainer,
    "load-more-cmp": LoadMore,
    "form-green-cmp": formGreen,
    "case-cmp": caseItem,
  },
  methods: {
    ...mapActions("modal", ["modalType_collabOpen", "modalClose"]),

    setPagination() {
      setTimeout(() => {
        this.pagination = this.$root.convertTwigToJs("pagination", ".js-pagination-blog")
      }, 100)
    },
    scrollToContainer() {
      let top =
        this.$refs.container.getBoundingClientRect().top + window.pageYOffset - document.querySelector("header").clientHeight - 24
      window.scrollTo({
        top: top,
        behavior: "smooth",
      })
    },
  },
  mounted() {
    this.setPagination()
  },
  beforeRouteUpdate(to, from, next) {
    // если не loadMore
    if (!to.query.loadMore) {
      const path = to.path.replace(router.history.base, "")
      this.$root.setDataAnimateFalse()

      Vue.http.get(`templates${path}`, { params: to.query }).then(
        data => {
          next()
          setTimeout(() => {
            this.template = data.data
            this.setPagination()
            this.newCases = []
            onScrollAnimate()
            if (this.$refs.casesSwiper) {
              this.$refs.casesSwiper.swiper.update()
            }
            this.scrollToContainer()
          }, 500)
        },
        () => {
          next("/404")
        }
      )
    } else {
      this.disableLoadMore = true
      let url = process.env.NODE_ENV !== "production" ? "cases/index.json" : to.path.substring(1).replace(router.history.base, "")

      Vue.http.get(url, { params: to.query }).then(
        data => {
          next()
          this.newCases = this.newCases.concat(data.data.items)
          this.pagination = data.data.pagination
          this.disableLoadMore = false
          setTimeout(() => {
            onScrollAnimate()
          }, 10)
        },
        () => {
          this.disableLoadMore = false
          next("/404")
        }
      )
    }
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/cases/index.js